
import React from 'react'
import { FloatingMenu, MenuItem, Icon } from '@evertel/web/ui'
import { APIDataDocumentSchema } from '@evertel/types'

interface OptionsMenuProps {
    schema: APIDataDocumentSchema
    onCreate?: () => void
    onClone?: (schema: APIDataDocumentSchema) => void
    canManage: boolean
}

export const OptionsMenu: React.FC<OptionsMenuProps> = ({
    schema,
    onCreate,
    onClone,
    canManage
}) => {

    const handleClone = (e) => {
        e.stopPropagation()
        if (onClone){
            onClone(schema)
        }
    }
    return (
        <FloatingMenu
            label={`${schema.name} Actions Menu`}
            renderLabel={() => (
                <Icon
                    name="ellipsis-v"
                    color="gray600"
                />
            )}
            className="document-options-menu py-0 px-2"
            data-drawer-nav="category"
        >
            {onCreate && (
                <MenuItem
                    label="Create Document"
                    to={`/everdocs/add/${schema.id}`}
                    onClick={onCreate}
                />
            )}
            {canManage && (
                <MenuItem
                    label="Edit Template"
                    to={`/everdocs/schema/edit/${schema.id}`}
                />
            )}
            {canManage && onClone && (
                <MenuItem
                    label="Clone Template"
                    onClick={handleClone}
                />
            )}
        </FloatingMenu>
    )
}
